"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Avatar.default;
  }
});

var _Avatar = _interopRequireDefault(require("./Avatar"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Avatar/index.js
// module id = 633
// module chunks = 0